/**
 * Shared constants for Settings section components
 */

/**
 * Danger button style for destructive actions (delete, disconnect, etc.)
 * Used across Settings components for consistent destructive action styling
 */
export const dangerButtonStyle =
  'border border-chariot-stroke-critical bg-chariot-status-critical hover:bg-chariot-status-critical/80 disabled:border-transparent';

/**
 * Masked placeholder for sensitive values stored in AWS Secrets Manager.
 * Used in notification modals (webhook, chat) where actual values cannot be retrieved.
 */
export const MASKED_PLACEHOLDER = '*************';

/**
 * System-managed rate limit defaults enforced by the backend.
 * When no custom rate limits are configured, the system applies these limits.
 * These values are NOT "unlimited" - they represent the actual backend enforcement.
 */
export const RATE_LIMIT_SYSTEM_DEFAULTS = {
  /** Maximum number of simultaneous hosts that can be scanned */
  SIMULTANEOUS_HOSTS: 1500,
  /** Maximum requests per second per host */
  REQUESTS_PER_HOST: 300,
} as const;
